const openUrl = url => url && window.open(`//${url}`, '_blank');

export default openUrl;
